<script>
  import {onMount, onDestroy} from 'svelte'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import {media} from 'svelte-match-media'

  import AnimatedBullets from '../components/AnimatedBullets.svelte'
  import AnimatedTitle from '../components/AnimatedTitle.svelte'
  import Diagram from '../charts/VerizonMediaIdentity.svelte'

  let boxesEl, st

  $: useMobile = $media.mobile

  onMount(() => {
    boxesEl.querySelectorAll('.box').forEach((box, index) => {
      const tl = gsap.timeline()
      tl.from(box, {
        xPercent: () => useMobile ? 50 : 0,
        y: () => useMobile ? 0 : 50,
        opacity: 0,
        ease: 'power2.out',
        duration: 0.85,
      }, useMobile ? 0 : index * .2)

      st = ScrollTrigger.create({
        trigger: useMobile ? box : boxesEl,
        start: 'bottom bottom-=30',
        toggleActions: 'play play play pause',
        animation: tl
      })
    })
  })

  onDestroy(() => {
    st?.kill()
  })

</script>
<section class="part2">
  <div class="rgrid-md-3-4">
    <div class="col">
      <AnimatedTitle class="medium">Data powered by direct consumer relationships</AnimatedTitle>
      <AnimatedBullets delay={0.3}>
        <li>Verizon Media is the 4th largest publisher on the internet in the U.S. Our users are on the Yahoo, AOL, and Verizon ecosystem-signed into accounts, viewing content, searching and receiving emails.</li>
        <li>Our identity graph is rooted in deterministic signals drawn from our known customer base. These signals allow us to be more confident and more accurate in our ability to target and measure performance, and be more compliant with consent-based user-privacy.</li>
        <li>In CTV, you can can bring your target audience into our DSP and reach them in a scaled manner with no added cost for identity.</li>
      </AnimatedBullets>
    </div>
  </div>
  <div class="diagram">
    <Diagram />
  </div>
  <AnimatedTitle class="medium">With our identity graph you can:</AnimatedTitle>
  <div class="full-width boxes-wrap">
    <div class="boxes" bind:this={boxesEl}>
      <div class="box">
        <h1 class="title">Target precise high-value audiences</h1>
      </div>
      <div class="box">
        <h1 class="title">Forecast, set, and measure frequency at the household and user level</h1>
      </div>
      <div class="box">
        <h1 class="title">Plan and measure across channels</h1>
      </div>
    </div>
  </div>
</section>

<style>
  .diagram {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  .diagram :global(svg) {
    margin: 0 auto;
  }
  .boxes-wrap {
    overflow: hidden;
  }
  .boxes {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-rows: 1fr;
  }
  .box {
    background: white;
    border: 1px solid black;
    padding: 2rem var(--gutter-sm) 2.5rem;
  }
  .box .title {
    color: black;
    max-width: 75%;
    margin: 0;
    font-weight: 500;
  }
  @media(min-width: 768px) {
    .boxes {
      grid-template-columns: repeat(3, 1fr);
      gap: calc(var(--gutter-lg) * 2);
    }
    .box {
      padding-bottom: 8rem;
    }
    .box .title {
      max-width: 100%;
    }
    .boxes-wrap {
      margin-left: 0;
      margin-right: 0;
    }
    .diagram {
      padding-top: 130px;
      padding-bottom: 130px;
    }
  }
</style>